import React from 'react';
import { Icon } from './Icon.js';
export const IconAlign3LeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "2", width: "14", height: "6", rx: "2.25", ry: "2.25", fill: "currentColor" }),
        React.createElement("rect", { x: "2", y: "10", width: "8", height: "6", rx: "2.25", ry: "2.25", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconAlign3LeftFill18.js.map